<div *ngIf="noteSections.length > 0">
  <div *ngFor="let noteSection of noteSections">
    <div [ngClass]="noteSection.noteClass || 'info-panel'">
      <div style="display: flex">
        <i [ngClass]="noteSection.iconClass || ''">&nbsp;</i>
        <p style="margin: 0" [innerHTML]="noteSection.body || '' | mdToHtml"></p>
      </div>
    </div>
  </div>
</div>
